import CommunityMember from './CommunityMember';

export default function CommunityPanel(props) {
    return (
        <div className="individuals individuals--alt form__individuals">
            <div className="individuals__head">
                <h6>
                    Community Members
                </h6>

                <div className="individuals__note">
															<span>
																How are these results different?
															</span>

                    <span>
																Community Members are verified based on education hours earned rather than project experience.
															</span>
                </div>
            </div>

            <div className="individuals__items">
                {props.hits.map((hit) => {
                    if (hit.directory_user_type !== 'Individuals' || hit.directory_user_type !== 'Companies') {
                        return <CommunityMember key={hit.objectID} hit={hit}/>
                    }
                })}
            </div>
        </div>
    )
}
